import { useTranslation } from 'react-i18next';
import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/articles';

export default function LatestArticles() {
  const { t } = useTranslation();
  const latest = [...articles].sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()).slice(0, 6);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-12">
          <div>
            <span className="inline-block px-4 py-1 bg-primary-100 text-primary-700 text-xs font-semibold rounded-full uppercase tracking-wider mb-4">
              Latest
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
              {t('section.latest')}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {latest.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}